<template>
  <div class="getResult" v-loading="load">
    <div class="personal-message">
      <div class="message-left">
        <img height="86px" width="67px" src="../../../static/image/defaultImg.png" alt="用户头像" />
        <!-- <div class="personal-name">
          <div class="name">姓 名：{{uesrs.examStudent.student.name}}</div>
          <div class="name">性 别：{{uesrs.examStudent.student.sex==1?"男":'女'}}</div>
          <div class="name">手机号：{{uesrs.examStudent.student.mobile}}</div>
        </div> -->
      </div>
      <div class="message-center">
        <!-- <div>会计专业技术资格</div> -->
        <div style="font-size:26px">无纸化考试模拟系统</div>
        <div>{{newNames}}</div>
      </div>
      <div class="message-right">
        <div class="message-rights">
          <img width="31px" height="31px" style="margin-right:10px;" src="../../../static/image/date.png" alt />
          <div>
            考试时间： {{(timer.hour>9)?timer.hour:("0"+timer.hour)}}:
            {{(timer.minute>9)?timer.minute:("0"+timer.minute)}}:
            {{(timer.second>9)?timer.second:("0"+timer.second)}}
          </div>
        </div>
      </div>
    </div>
    <div class="mian-content">
      <div style="width:23%">
        <div class="right-contents" v-if="show==false||show=='false'">
          <div class="right-contents-item" v-for="(item,index) in cardList" :key="index">
            <div class="right-contents-item-title">{{item.typeName}}</div>
            <div class="right-contents-item-chengou">
              <div class="chenlaogou">
                <div class="chengou" :class="isInArray(element,wrongTrue.correctNumberList)?'select-item ge':isInArray(element,norNumberList)?'select-item':'select-item  re'" v-for="(element,inx) in item.numberList" :key="inx" @click="goIndex(element-1)">
                  <div style="color: #4C92EB;">{{element}}</div>
                  <div>
                    <span style="color: #ff000c;" v-if="questionList[element-1].check">?</span>
                    <span v-else-if="questionList[element-1].userAnswer==''||questionList[element-1].userAnswer==[]||questionList[element-1].userAnswer==null">*</span>
                    <span v-else>&nbsp;</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-contents" v-else>
          <div class="right-contents-item" v-for="(item,index) in cardList" :key="index">
            <div class="right-contents-item-title">{{item.typeName}}</div>
            <div class="right-contents-item-chengou">
              <div class="chenlaogou">
                <div class="chengou" :class="'select-item  re'" v-for="(element,inx) in item.numberList" :key="inx" @click="goIndex(element-1)">
                  <div>{{element}}</div>
                  <div>
                    <span style="color: #ff000c;" v-if="questionList[element-1].check">?</span>
                    <span v-else-if="questionList[element-1].userAnswer==''||questionList[element-1].userAnswer==[]||questionList[element-1].userAnswer==null">*</span>
                    <span v-else>&nbsp;</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-titles">
          <div>说明:1.题号下方的*符号代表该小题尚未作答</div>
          <div>2.题号下方的?符号代表该小题做过标记！</div>
          <div>3.选择选项的同时自动保存答案！</div>
        </div>
        <div class="right-buttons" @click="counterDialogVisible=true">
          <img src="../../../static/image/jsq.png" alt />
          <div>计算器</div>
        </div>
      </div>
      <div style="border: solid 1px rgba(176, 190, 213, 1);width:77%;background: rgba(221, 235, 246, 1);
      ">
        <div class="question-title">试题</div>

        <div class="question" style="padding-bottom:60px" v-if="questionList[nowIndex]">
          <div class="question-name">
            <div class="name">{{nowIndex+1}} 、{{questionList[nowIndex].questionTypeName}}</div>
            <div>
              <div v-html="questionList[nowIndex].ptitle"></div>
              <div v-html="questionList[nowIndex].title"></div>
            </div>
          </div>
          <div class="question-answer-result" v-if="questionList[nowIndex].mode=='多选'">
            <div v-for="(items,indexs) in questionList[nowIndex].optionList" :key="indexs">
              <div style="margin-left:30px;">
                <i v-if=" isInArray(items.options,questionList[nowIndex].answer)" style="font-size: 14px;color:rgba(65, 212, 151, 1)" class="iconfont icon-xuanze-fangkuang-tianchong"></i>
                <i v-else-if="isInArray(items.options,questionList[nowIndex].userAnswers)" style="font-size: 14px;color:#fc5e5e" class="iconfont icon-cuowu-fangkuang-tianchong"></i>
                <i v-else style="font-size: 14px;color:#a2aabc" class="iconfont icon-fangkuang"></i>
                <span style="color: rgb(162, 170, 188);">{{items.options}}.</span>
                <span v-html="items.name" style="white-space: normal;line-height: 40px !important;"></span>
              </div>
            </div>
          </div>

          <div class="question-answer-result" v-if="questionList[nowIndex].mode=='单选'">
            <div v-for="(items,indexs) in questionList[nowIndex].optionList" :key="indexs">
              <div style="margin-left:30px;">
                <i v-if=" questionList[nowIndex].answer==items.options" style="font-size: 14px;color:rgba(65, 212, 151, 1)" class="iconfont icon-zhengque1"></i>
                <i v-else-if="questionList[nowIndex].userAnswer==items.options&&questionList[nowIndex].answer!=items.options" style="font-size: 14px;color:#fc5e5e" class="iconfont icon-cuowu"></i>
                <i v-else style="font-size: 14px;color:#a2aabc" class="iconfont icon-quan"></i>
                <span style="color: rgb(162, 170, 188);">{{items.options}}.</span>
                <span v-html="items.name" style="white-space: normal;line-height: 40px !important;"></span>
              </div>
            </div>
          </div>
          <div class="question-answer-result" v-if="questionList[nowIndex].mode=='判断'">
            <div style="margin-left:30px;">
              <i v-if="questionList[nowIndex].answer=='对'" style="font-size:21px;color:rgba(65, 212, 151, 1)" class="iconfont icon-zhengque1"></i>
              <i v-else-if="questionList[nowIndex].userAnswer=='对'&&questionList[nowIndex].answer=='错'" style="font-size:21px;color:#fc5e5e" class="iconfont icon-cuowu"></i>
              <i v-else style="font-size:21px;color:#a2aabc" class="iconfont icon-quan"></i>

              <span style="white-space: normal;line-height: 40px !important;">对</span>
            </div>
            <div style="margin-left:30px;">
              <i v-if="questionList[nowIndex].answer=='错'" style="font-size:21px;color:rgba(65, 212, 151, 1)" class="iconfont icon-zhengque1"></i>
              <i v-else-if="questionList[nowIndex].userAnswer=='错'&&questionList[nowIndex].answer=='对'" style="font-size:21px;color:#fc5e5e" class="iconfont icon-cuowu"></i>
              <i v-else style="font-size:21px;color:#a2aabc" class="iconfont icon-quan"></i>
              <span style="white-space: normal;line-height: 40px !important;">错</span>
            </div>
          </div>
          <div class="question-answer" v-if="questionList[nowIndex].mode=='填写'">
            <ue :id="'id'+nowIndex" :ids="nowIndex" :value="questionList[nowIndex].userAnswer"></ue>
          </div>
          <div class="last">
            <div class="last-item" v-if="questionList[nowIndex].page">
              <span style="color:#333;white-space: nowrap !important;font-size:13px">教材页码：</span>
              <span style=";font-size:13px">{{questionList[nowIndex].page?questionList[nowIndex].page:"无"}}</span>
            </div>
            <div class="last-item" v-if="questionList[nowIndex].hard">
              <span style="color:#333;white-space: nowrap !important;font-size:13px">试卷难度：</span>
              <span>
                <el-rate style="display: inline-block;" disabled :colors="rateColors" v-model="questionList[nowIndex].hard"></el-rate>
              </span>
            </div>
            <div class="last-item">
              <span style="color:#333;white-space: nowrap !important;font-size:13px">
                参考解析
                ：
              </span>
              <span v-html="questionList[nowIndex].analysis"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-button">
        <div class="flex-item">
          <!-- <input style="" type="checkbox" />标记 -->
          <!-- <el-checkbox @change="collectQuestion" v-model="questionList[nowIndex].collect">标记</el-checkbox> -->
        </div>
        <div class="flex-item" @click="goIndex(nowIndex-1)">
          <!-- <span></span> -->
          <button :disabled="nowIndex==0?true:false">上一题</button>
        </div>

        <div class="flex-item" @click="goIndex(nowIndex+1)">
          <button :disabled="nowIndex==questionList.length-1?true:false">下一题</button>
        </div>
      </div>
    </div>
    <drag @closeDialog="closeDialogEvement()" v-if="counterDialogVisible"></drag>
  </div>
</template>

<script>
import drag from "../common/drag";
import ue from "../common/UE";
import elDragDialog from "../directive/el-drag-dialog";
export default {
  components: { ue, drag },
  directives: { elDragDialog },
  data () {
    return {
      uesrs: {
        examStudent: {
          student: {}
        }
      },
      timer: {
        hour: 0,
        minute: 0,
        second: 60
      },
      show: false,
      rateColors: ["#c7000a", "#c7000a", "#c7000a"],
      questionList: [{ check: false }],
      norNumberList: [],
      correctNumberList: [],
      cardList: [],
      nowIndex: 0,
      showResult: false,
      wrongTrue: JSON.parse(localStorage.getItem("wrongTrue")),
      load: false,
      typeId: null,
      counterDialogVisible: false
    };
  },
  created () { },
  methods: {
    collectQuestion () {
      // this.api.question
      //   .collectQuestion({
      //     typeId: this.typeId,
      //     type: "exam",
      //     questionId: this.questionList[this.nowIndex].id
      //   })
      //   .then(res => {
      //     if (res.code == 0) {
      //       this.$message.success(res.msg);
      //       // this.$set(
      //       //   this.questionList[this.nowIndex],
      //       //   "collect",
      //       //   !this.questionList[this.nowIndex].collect
      //       // );
      //       // this.questionList[this.nowIndex].collect = !this.questionList[
      //       //   this.nowIndex
      //       // ].collect;
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   });
    },
    closeDialogEvement () {
      this.counterDialogVisible = false;
    },
    getQuestionByExercise () {
      this.load = true;
      this.api.question
        .simulateGetQuestionByExercise({
          exerciseId: this.$route.query.exerciseId,
          wrongOnly: this.$route.query.sty
        })
        .then(res => {
          if (res.code == 0) {
            this.load = false;
            let counts = 0;

            res.data.forEach((element, index) => {
              let indexs = index + 1;
              if (element.mode == "填写") {
                if (!element.userAnswer) {
                  element.userAnswer = "未作答";
                }
              }
              if (element.userAnswer) {
                counts++;
              }
              element.stys = 3;
              if (element.userAnswer) {
                if (this.isInArray(indexs, this.correctNumberList)) {
                  //   this.resultNums.yes = this.resultNums.yes + 1;
                  element.stys = 1;
                } else {
                  //   this.resultNums.no = this.resultNums.no + 1;
                  element.stys = 2;
                }
              }
              element.showAnalysis = true;
              if (element.mode == "多选") {
                if (element.userAnswer.length == 0) {
                  this.norNumberList.push(index + 1);
                }
                console.log(element.mode, index);
                element.answers = element.answer;
                element.answer =
                  element.answer != null ? element.answer.split(",") : "";
                element.userAnswers =
                  element.userAnswer != null
                    ? element.userAnswer.split(",")
                    : "";
              } else {
                if (!element.userAnswer) {
                  this.norNumberList.push(index + 1);
                }
              }
            });
            if (res.exerciseTime) {
              this.timer.hour = Math.floor(res.exerciseTime / 60) || 0;
              if (res.exerciseTime % 60 == 0) {
                this.timer.hour = this.timer.hour - 1;
                this.timer.minute = 59;
              } else {
                this.timer.minute = (res.exerciseTime % 60) - 1;
              }
              this.timer.second = 60;
            }
            this.cardList = res.cardList;
            this.typeId = res.typeId;
            this.doNumQuestions = counts;
            this.questionList = res.data;
            this.reportVisible = false;
            this.showResult = false;
            this.showSumbit = false;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    goIndex (index) {
      this.$nextTick(function () {
        this.nowIndex = index;
      });
    },
    getExamSettingInfo () {
      this.api.examStudent
        .simulateGetExamSettingInfo({
          examSettingId: this.$route.query.examSettingId
        })
        .then(res => {
          if (res.code == 0) {
            this.uesrs = res.data;
            this.getQuestionByExercise();
          } else {
            this.$message.error(res.msg);
          }
        });
    }
  },
  watch: {},
  computed: {
    newNames () {
      // return localStorage.getItem("newNames");
    }
  },
  mounted () {
    this.show = this.$route.query.sty;
    this.getExamSettingInfo();
  }
};
</script>

<style lang="less" rel="stylesheet/less">
@import "../../../static/css/main.less";
.getResult {
  p {
    display: inline;
  }
  display: flex;
  width: 1200px;
  margin: auto;
  height: 100%;
  background-color: rgb(246, 249, 250);
  flex-direction: column;
  .mian-content {
    display: flex;
    margin-top: 10px;
    position: relative;
    .tab-button {
      padding: 10px;
      margin-left: 30px;
      position: absolute;
      bottom: 0px;
      display: flex;
      left: 23%;
      .flex-item {
        margin-right: 20px;
        label {
          display: block !important;
          margin-top: -4px !important;
          margin-bottom: 10px !important;
          display: flex !important;
          align-items: flex-start !important;
          justify-content: flex-start !important;
          .el-radio__input.is-checked .el-radio__inner {
            border-color: rgb(160, 170, 188) !important;
            background: rgb(160, 170, 188) !important;
          }
          .el-checkbox__input.is-checked + .el-checkbox__label {
            color: rgb(69, 90, 100) !important;
          }
          .el-checkbox__inner {
            width: 12px !important;
            height: 12px !important;
            border: 1px solid #333 !important;
          }
          .el-checkbox__inner::after {
            height: 8px !important;
            left: 3px !important;
            top: 0px !important;
            border: 1px solid #333 !important;
            border-left: 0 !important;
            border-top: 0 !important;
            //   transform: rotate(45deg) scaleY(1) !important;
          }
          .el-checkbox__input {
            margin-top: 4px !important;
            line-height: 30px !important;
          }
          .el-checkbox__input.is-checked .el-checkbox__inner {
            border-color: #333 !important;
            background: #ffffff !important;
          }
          .el-checkbox__input.is-checked .el-checkbox__inner {
            &:hover {
              border-color: rgb(160, 170, 188) !important;
            }
          }
          .el-checkbox__label {
            font-size: 13px !important;
            line-height: 35px !important;
            color: #333 !important;
          }
        }
      }
    }
    .question-answer-result {
      line-height: 20px;
      span {
        font-size: 13px;
      }
      i {
        font-size: 13px;
      }
    }
    .question {
      border-top: solid 2px rgba(49, 118, 173, 1);
      padding: 0 10px;
      .question-answer {
        // margin-left: 30px;
        margin-top: 10px;
        display: flex;
        justify-content: flex-start;
        p {
          display: inline;
        }
        .el-checkbox-group {
          width: 100% !important;

          .el-checkbox {
            margin-right: 30px !important;
            line-height: 30px !important;

            padding: 0 10px;
            // &:hover {
            //   background: rgb(246, 249, 250);
            // }
          }
          label {
            display: block !important;
            // height: 40px !important;
            margin-bottom: 10px !important;
            display: flex !important;
            align-items: flex-start !important;
            justify-content: flex-start !important;
            .el-radio__input.is-checked .el-radio__inner {
              border-color: rgb(160, 170, 188) !important;
              background: rgb(160, 170, 188) !important;
            }
            .el-checkbox__input.is-checked + .el-checkbox__label {
              color: rgb(69, 90, 100) !important;
            }
            .el-checkbox__inner {
              width: 12px !important;
              height: 12px !important;
              border: 1px solid #333 !important;
            }
            .el-checkbox__inner::after {
              height: 8px !important;
              left: 3px !important;
              top: 0px !important;
              border: 1px solid #333 !important;
              border-left: 0 !important;
              border-top: 0 !important;
              //   transform: rotate(45deg) scaleY(1) !important;
            }
            .el-checkbox__input {
              margin-top: 4px !important;
              line-height: 30px !important;
            }
            .el-checkbox__input.is-checked .el-checkbox__inner {
              border-color: #333 !important;
              background: #ffffff !important;
            }
            .el-checkbox__input.is-checked .el-checkbox__inner {
              &:hover {
                border-color: rgb(160, 170, 188) !important;
              }
            }
            .el-checkbox__label {
              font-size: 16px !important;
              line-height: 35px !important;
              color: rgb(69, 90, 100) !important;
            }
          }
        }
        .el-radio-group {
          width: 100% !important;
          .el-radio {
            margin-right: 30px !important;
            padding: 0 10px;
            display: flex !important;
            align-items: flex-start !important;
            // &:hover {
            //   background: rgb(246, 249, 250);
            // }
          }

          .el-radio__input {
            line-height: 32px !important;
          }
          label {
            display: block !important;
            line-height: 30px !important;
            margin-bottom: 10px !important;
            .el-radio__input.is-checked .el-radio__inner {
              border-color: rgb(121, 121, 121) !important;
              background: #fff !important;
            }
            .el-radio__inner {
              width: 12px !important;
              height: 12px !important;
              border-color: rgb(121, 121, 121) !important;
            }
            .el-radio__inner::after {
              width: 6px !important;
              background: rgb(121, 121, 121) !important;
              height: 6px !important;
            }
            .el-radio__label {
              font-size: 16px !important;
              color: rgb(69, 90, 100) !important;
            }
          }
        }
      }
      .question-name {
        line-height: 24px;
        text-align: left;
        p {
          display: inline;
        }
        font-size: 13px;

        .name {
          font-family: "微软雅黑 Bold", "微软雅黑";
          font-weight: 700;
          font-style: normal;
          color: #323232;
          font-size: 13px;
          border-bottom: solid 1px rgba(176, 190, 213, 1);
        }
      }
    }
    .question-title {
      width: 132px;
      .center();
      height: 32px;
      border: solid 1px rgba(49, 118, 173, 1);
      background: rgba(71, 144, 197, 1);
      border-radius: 10px;
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;
      box-sizing: border-box;
      box-shadow: none;
      font-family: "微软雅黑 Bold", "微软雅黑";
      font-weight: 400;
      font-style: normal;
      color: #323232;
      line-height: 13px;
    }
    .last {
      margin-left: 30px;
      .last-item {
        line-height: 30px;
        span,
        p {
          font-size: 13px;
        }
      }
    }
    .right-buttons {
      .center();
      padding: 1px;
      background-color: rgb(222, 222, 222);
      width: 99px;
      height: 36px;
      font-family: "微软雅黑 Bold", "微软雅黑";
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #323232;
      line-height: 14px;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(185, 185, 185, 1);
      border-radius: 4px;
      justify-content: flex-start;
      cursor: pointer;
      img {
        width: 32px;
        height: 32px;
      }
      div {
        margin-left: 10px;
      }
    }
    .right-titles {
      div {
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        color: #ff000c;
        line-height: 24px;
      }
    }
    .right-contents {
      .right-contents-item {
        .right-contents-item-chengou {
          background-color: rgba(222, 241, 248, 1);
          border: solid 1px rgba(175, 197, 247, 1);
          padding: 6px;

          .chenlaogou {
            border-top: solid 1px rgba(176, 190, 213, 1);
            border-left: solid 1px rgba(176, 190, 213, 1);
            display: inline-block;
            flex-wrap: wrap;

            .re {
              background: rgb(252, 94, 94);
              // border: rgb(252, 94, 94) 1px solid;
              color: #ffffff;
            }
            .ge {
              color: #ffffff;
              background: #41d497;
              // border: #41d497 1px solid;
            }
            .chengou {
              height: 34px;
              width: 21px;
              padding: 2px;
              text-align: center;
              display: inline-block;
              cursor: pointer;
              flex-direction: column;

              border-bottom: solid 1px rgba(176, 190, 213, 1);
              border-right: solid 1px rgba(176, 190, 213, 1);
            }
          }
          margin-bottom: 10px;
        }
        .right-contents-item-title {
          width: 100%;
          .center();
          height: 32px;
          border: solid 1px rgba(49, 118, 173, 1);
          background: rgba(71, 144, 197, 1);
          border-radius: 10px;
          border-bottom-right-radius: 0px;
          border-bottom-left-radius: 0px;
          box-sizing: border-box;
          box-shadow: none;
          font-family: "微软雅黑 Bold", "微软雅黑";
          font-weight: 400;
          font-style: normal;
          color: #323232;
          line-height: 13px;
        }
      }
    }
  }
  .personal-message {
    padding: 0 40px 0 10px;
    .center();
    background: linear-gradient(
      180deg,
      rgba(121, 186, 252, 1) 0%,
      rgba(111, 176, 233, 1) 100%
    );
    background: -webkit-linear-gradient(
      180deg,
      rgba(121, 186, 252, 1) 0%,
      rgba(111, 176, 233, 1) 100%
    );
    background: -o-linear-gradient(
      180deg,
      rgba(121, 186, 252, 1) 0%,
      rgba(111, 176, 233, 1) 100%
    );
    background: -moz-linear-gradient(
      180deg,
      rgba(121, 186, 252, 1) 0%,
      rgba(111, 176, 233, 1) 100%
    );
    justify-content: space-between;
    .message-center {
      .center();
      flex-direction: column;
      font-family: "微软雅黑 Bold", "微软雅黑";
      font-weight: 700;
      font-style: normal;
      font-size: 20px;
      color: #ffffff;
      text-align: center;
      line-height: 38px;
    }
    .message-left {
      padding: 20px 0;
      .center();
      .personal-name {
        margin-left: 10px;
        height: 76px;
        .center();
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        .name {
          font-family: "微软雅黑";
          font-weight: 400;
          font-style: normal;
          font-size: 16px;
          color: #fff;
          line-height: 16px;
        }
      }
    }
    .message-right {
      padding: 20px 0;
      width: 252px;
      .message-submit {
        .center();
        float: right;
        margin-top: 14px;
        width: 82px;
        height: 28px;
        background: linear-gradient(
          180deg,
          rgba(243, 229, 168, 1) 0%,
          rgba(248, 213, 88, 1) 50%,
          rgba(237, 151, 28, 1) 100%
        );
        background: -webkit-linear-gradient(
          180deg,
          rgba(243, 229, 168, 1) 0%,
          rgba(248, 213, 88, 1) 50%,
          rgba(237, 151, 28, 1) 100%
        );
        background: -o-linear-gradient(
          180deg,
          rgba(243, 229, 168, 1) 0%,
          rgba(248, 213, 88, 1) 50%,
          rgba(237, 151, 28, 1) 100%
        );
        background: -moz-linear-gradient(
          180deg,
          rgba(243, 229, 168, 1) 0%,
          rgba(248, 213, 88, 1) 50%,
          rgba(237, 151, 28, 1) 100%
        );
        border: 1px solid rgba(218, 151, 47, 1);
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        color: #323232;
        line-height: 12px;
      }
      .message-rights {
        display: none !important;
        width: 252px;
        .center();
        height: 46px;
        background: linear-gradient(
          180deg,
          rgba(255, 250, 230, 1) 0%,
          rgba(232, 210, 47, 1) 100%
        );
        background: -webkit-linear-gradient(
          180deg,
          rgba(255, 250, 230, 1) 0%,
          rgba(232, 210, 47, 1) 100%
        );
        background: -o-linear-gradient(
          180deg,
          rgba(255, 250, 230, 1) 0%,
          rgba(232, 210, 47, 1) 100%
        );
        background: -moz-linear-gradient(
          180deg,
          rgba(255, 250, 230, 1) 0%,
          rgba(232, 210, 47, 1) 100%
        );
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        color: #ff000c;
        font-size: 20px;
        border-radius: 6px;
        font-weight: bold;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fullTruthModelTest/getResult.vue